import React, { useEffect, useState } from "react";
import { IoMdAdd } from "react-icons/io"
import { AiFillHome } from "react-icons/ai";
import { IoIosArrowForward } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";

import SearchBar from "../../../components/searchBar/SearchBar";
import Table from "../../../components/tables/Table";
import Pagination from "../../../components/pagination/Pagination";
import Card from "../../../components/cards/Card";
import { MdDelete } from "react-icons/md";
import { FiEdit } from "react-icons/fi";
import ConfirmModal from "../../../components/popups/confirmationModal/ConfirmModal";
import { deleteFaqsApi, getFaqsApi } from "../../../services/apis/faqs";
import showAlert from "../../../components/errorBoundries/Errors";
import Toast, { showSuccessToast } from "../../../components/toastify/Toast";

const FAQs = () => {
  const navigate = useNavigate();
  const headers = ["Date Posted", "Faq type", "Questions", "Answers"];
  const keys = ["created_at", "faq_type", "question", "answer"];
  const [modalIsOpen, setIsOpen] = useState(false);
  const [faqsData, setFaqsData] = useState({});
  const [faqsId, setFaqsId] = useState("");
  const [isConfirmDelete, setIsConfirmDelete] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const availableIcons = [
    <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="8" fill="#1C64F2" />
      <path d="M24 12C21.6266 12 19.3066 12.7038 17.3332 14.0224C15.3598 15.3409 13.8217 17.2151 12.9135 19.4078C12.0052 21.6005 11.7676 24.0133 12.2306 26.3411C12.6936 28.6689 13.8365 30.807 15.5147 32.4853C17.193 34.1635 19.3311 35.3064 21.6589 35.7694C23.9867 36.2324 26.3995 35.9948 28.5922 35.0865C30.7849 34.1783 32.6591 32.6402 33.9776 30.6668C35.2962 28.6934 36 26.3734 36 24C35.9965 20.8185 34.7311 17.7683 32.4814 15.5186C30.2317 13.2689 27.1815 12.0035 24 12ZM24 31.2C23.7627 31.2 23.5307 31.1296 23.3333 30.9978C23.136 30.8659 22.9822 30.6785 22.8913 30.4592C22.8005 30.2399 22.7768 29.9987 22.8231 29.7659C22.8694 29.5331 22.9837 29.3193 23.1515 29.1515C23.3193 28.9836 23.5331 28.8694 23.7659 28.8231C23.9987 28.7768 24.24 28.8005 24.4592 28.8913C24.6785 28.9822 24.8659 29.136 24.9978 29.3333C25.1296 29.5306 25.2 29.7627 25.2 30C25.2 30.3183 25.0736 30.6235 24.8485 30.8485C24.6235 31.0736 24.3183 31.2 24 31.2ZM25.2 25.7592V26.4C25.2 26.7183 25.0736 27.0235 24.8485 27.2485C24.6235 27.4736 24.3183 27.6 24 27.6C23.6817 27.6 23.3765 27.4736 23.1515 27.2485C22.9264 27.0235 22.8 26.7183 22.8 26.4V24.6984C22.8 24.5368 22.8326 24.3769 22.8959 24.2282C22.9592 24.0795 23.0519 23.9452 23.1684 23.8332C23.284 23.7205 23.4215 23.6328 23.5724 23.5754C23.7233 23.518 23.8843 23.4922 24.0456 23.4996C24.2776 23.508 24.5089 23.4695 24.7256 23.3862C24.9424 23.303 25.14 23.1769 25.3068 23.0154C25.4736 22.8539 25.606 22.6604 25.6961 22.4464C25.7862 22.2325 25.8322 22.0025 25.8312 21.7704C25.8497 21.293 25.6777 20.8278 25.3532 20.4772C25.0287 20.1266 24.5782 19.9193 24.1008 19.9008C23.6234 19.8823 23.1582 20.0543 22.8076 20.3788C22.457 20.7033 22.2497 21.1538 22.2312 21.6312C22.2274 21.7893 22.1919 21.9451 22.1269 22.0893C22.0619 22.2335 21.9686 22.3631 21.8526 22.4706C21.7366 22.5782 21.6002 22.6613 21.4515 22.7152C21.3028 22.7691 21.1448 22.7926 20.9868 22.7844C20.6691 22.7719 20.3693 22.6338 20.1534 22.4005C19.9374 22.1672 19.8228 21.8577 19.8348 21.54C19.8689 20.7683 20.1151 20.021 20.5464 19.3802C20.9776 18.7394 21.5773 18.2299 22.2793 17.9078C22.9814 17.5857 23.7587 17.4635 24.5257 17.5545C25.2927 17.6455 26.0198 17.9463 26.627 18.4238C27.2341 18.9013 27.6979 19.5369 27.9672 20.2609C28.2365 20.9848 28.3009 21.769 28.1534 22.5272C28.0059 23.2854 27.6522 23.9883 27.1312 24.5585C26.6101 25.1287 25.9419 25.5442 25.2 25.7592Z" fill="white" />
    </svg>,
    <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="8" fill="#1A8044" />
      <path d="M24 12C21.6266 12 19.3066 12.7038 17.3332 14.0224C15.3598 15.3409 13.8217 17.2151 12.9135 19.4078C12.0052 21.6005 11.7676 24.0133 12.2306 26.3411C12.6936 28.6689 13.8365 30.807 15.5147 32.4853C17.193 34.1635 19.3311 35.3064 21.6589 35.7694C23.9867 36.2324 26.3995 35.9948 28.5922 35.0865C30.7849 34.1783 32.6591 32.6402 33.9776 30.6668C35.2962 28.6934 36 26.3734 36 24C35.9965 20.8185 34.7311 17.7683 32.4814 15.5186C30.2317 13.2689 27.1815 12.0035 24 12V12ZM24 31.2C23.7627 31.2 23.5307 31.1296 23.3333 30.9978C23.136 30.8659 22.9822 30.6785 22.8913 30.4592C22.8005 30.2399 22.7768 29.9987 22.8231 29.7659C22.8694 29.5331 22.9837 29.3193 23.1515 29.1515C23.3193 28.9836 23.5331 28.8694 23.7659 28.8231C23.9987 28.7768 24.24 28.8005 24.4592 28.8913C24.6785 28.9822 24.8659 29.136 24.9978 29.3333C25.1296 29.5306 25.2 29.7627 25.2 30C25.2 30.3183 25.0736 30.6235 24.8485 30.8485C24.6235 31.0736 24.3183 31.2 24 31.2ZM25.2 25.7592V26.4C25.2 26.7183 25.0736 27.0235 24.8485 27.2485C24.6235 27.4736 24.3183 27.6 24 27.6C23.6817 27.6 23.3765 27.4736 23.1515 27.2485C22.9264 27.0235 22.8 26.7183 22.8 26.4V24.6984C22.8 24.5368 22.8326 24.3769 22.8959 24.2282C22.9592 24.0795 23.0519 23.9452 23.1684 23.8332C23.284 23.7205 23.4215 23.6328 23.5724 23.5754C23.7233 23.518 23.8843 23.4922 24.0456 23.4996C24.2776 23.508 24.5089 23.4695 24.7256 23.3862C24.9424 23.303 25.14 23.1769 25.3068 23.0154C25.4736 22.8539 25.606 22.6604 25.6961 22.4464C25.7862 22.2325 25.8322 22.0025 25.8312 21.7704C25.8497 21.293 25.6777 20.8278 25.3532 20.4772C25.0287 20.1266 24.5782 19.9193 24.1008 19.9008C23.6234 19.8823 23.1582 20.0543 22.8076 20.3788C22.457 20.7033 22.2497 21.1538 22.2312 21.6312C22.2274 21.7893 22.1919 21.9451 22.1269 22.0893C22.0619 22.2335 21.9686 22.3631 21.8526 22.4706C21.7366 22.5782 21.6002 22.6613 21.4515 22.7152C21.3028 22.7691 21.1448 22.7926 20.9868 22.7844C20.6691 22.7719 20.3693 22.6338 20.1534 22.4005C19.9374 22.1672 19.8228 21.8577 19.8348 21.54C19.8689 20.7683 20.1151 20.021 20.5464 19.3802C20.9776 18.7394 21.5773 18.2299 22.2793 17.9078C22.9814 17.5857 23.7587 17.4635 24.5257 17.5545C25.2927 17.6455 26.0198 17.9463 26.627 18.4238C27.2341 18.9013 27.6979 19.5369 27.9672 20.2609C28.2365 20.9848 28.3009 21.769 28.1534 22.5272C28.0059 23.2854 27.6522 23.9883 27.1312 24.5585C26.6101 25.1287 25.9419 25.5442 25.2 25.7592Z" fill="white" />
    </svg>,
    <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="8" fill="#63C700" />
      <path d="M24 12C21.6266 12 19.3066 12.7038 17.3332 14.0224C15.3598 15.3409 13.8217 17.2151 12.9135 19.4078C12.0052 21.6005 11.7676 24.0133 12.2306 26.3411C12.6936 28.6689 13.8365 30.807 15.5147 32.4853C17.193 34.1635 19.3311 35.3064 21.6589 35.7694C23.9867 36.2324 26.3995 35.9948 28.5922 35.0865C30.7849 34.1783 32.6591 32.6402 33.9776 30.6668C35.2962 28.6934 36 26.3734 36 24C35.9965 20.8185 34.7311 17.7683 32.4814 15.5186C30.2317 13.2689 27.1815 12.0035 24 12V12ZM24 31.2C23.7627 31.2 23.5307 31.1296 23.3333 30.9978C23.136 30.8659 22.9822 30.6785 22.8913 30.4592C22.8005 30.2399 22.7768 29.9987 22.8231 29.7659C22.8694 29.5331 22.9837 29.3193 23.1515 29.1515C23.3193 28.9836 23.5331 28.8694 23.7659 28.8231C23.9987 28.7768 24.24 28.8005 24.4592 28.8913C24.6785 28.9822 24.8659 29.136 24.9978 29.3333C25.1296 29.5306 25.2 29.7627 25.2 30C25.2 30.3183 25.0736 30.6235 24.8485 30.8485C24.6235 31.0736 24.3183 31.2 24 31.2ZM25.2 25.7592V26.4C25.2 26.7183 25.0736 27.0235 24.8485 27.2485C24.6235 27.4736 24.3183 27.6 24 27.6C23.6817 27.6 23.3765 27.4736 23.1515 27.2485C22.9264 27.0235 22.8 26.7183 22.8 26.4V24.6984C22.8 24.5368 22.8326 24.3769 22.8959 24.2282C22.9592 24.0795 23.0519 23.9452 23.1684 23.8332C23.284 23.7205 23.4215 23.6328 23.5724 23.5754C23.7233 23.518 23.8843 23.4922 24.0456 23.4996C24.2776 23.508 24.5089 23.4695 24.7256 23.3862C24.9424 23.303 25.14 23.1769 25.3068 23.0154C25.4736 22.8539 25.606 22.6604 25.6961 22.4464C25.7862 22.2325 25.8322 22.0025 25.8312 21.7704C25.8497 21.293 25.6777 20.8278 25.3532 20.4772C25.0287 20.1266 24.5782 19.9193 24.1008 19.9008C23.6234 19.8823 23.1582 20.0543 22.8076 20.3788C22.457 20.7033 22.2497 21.1538 22.2312 21.6312C22.2274 21.7893 22.1919 21.9451 22.1269 22.0893C22.0619 22.2335 21.9686 22.3631 21.8526 22.4706C21.7366 22.5782 21.6002 22.6613 21.4515 22.7152C21.3028 22.7691 21.1448 22.7926 20.9868 22.7844C20.6691 22.7719 20.3693 22.6338 20.1534 22.4005C19.9374 22.1672 19.8228 21.8577 19.8348 21.54C19.8689 20.7683 20.1151 20.021 20.5464 19.3802C20.9776 18.7394 21.5773 18.2299 22.2793 17.9078C22.9814 17.5857 23.7587 17.4635 24.5257 17.5545C25.2927 17.6455 26.0198 17.9463 26.627 18.4238C27.2341 18.9013 27.6979 19.5369 27.9672 20.2609C28.2365 20.9848 28.3009 21.769 28.1534 22.5272C28.0059 23.2854 27.6522 23.9883 27.1312 24.5585C26.6101 25.1287 25.9419 25.5442 25.2 25.7592Z" fill="white" />
    </svg>,
    <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="8" fill="#C70048" />
      <path d="M24 12C21.6266 12 19.3066 12.7038 17.3332 14.0224C15.3598 15.3409 13.8217 17.2151 12.9135 19.4078C12.0052 21.6005 11.7676 24.0133 12.2306 26.3411C12.6936 28.6689 13.8365 30.807 15.5147 32.4853C17.193 34.1635 19.3311 35.3064 21.6589 35.7694C23.9867 36.2324 26.3995 35.9948 28.5922 35.0865C30.7849 34.1783 32.6591 32.6402 33.9776 30.6668C35.2962 28.6934 36 26.3734 36 24C35.9965 20.8185 34.7311 17.7683 32.4814 15.5186C30.2317 13.2689 27.1815 12.0035 24 12V12ZM24 31.2C23.7627 31.2 23.5307 31.1296 23.3333 30.9978C23.136 30.8659 22.9822 30.6785 22.8913 30.4592C22.8005 30.2399 22.7768 29.9987 22.8231 29.7659C22.8694 29.5331 22.9837 29.3193 23.1515 29.1515C23.3193 28.9836 23.5331 28.8694 23.7659 28.8231C23.9987 28.7768 24.24 28.8005 24.4592 28.8913C24.6785 28.9822 24.8659 29.136 24.9978 29.3333C25.1296 29.5306 25.2 29.7627 25.2 30C25.2 30.3183 25.0736 30.6235 24.8485 30.8485C24.6235 31.0736 24.3183 31.2 24 31.2ZM25.2 25.7592V26.4C25.2 26.7183 25.0736 27.0235 24.8485 27.2485C24.6235 27.4736 24.3183 27.6 24 27.6C23.6817 27.6 23.3765 27.4736 23.1515 27.2485C22.9264 27.0235 22.8 26.7183 22.8 26.4V24.6984C22.8 24.5368 22.8326 24.3769 22.8959 24.2282C22.9592 24.0795 23.0519 23.9452 23.1684 23.8332C23.284 23.7205 23.4215 23.6328 23.5724 23.5754C23.7233 23.518 23.8843 23.4922 24.0456 23.4996C24.2776 23.508 24.5089 23.4695 24.7256 23.3862C24.9424 23.303 25.14 23.1769 25.3068 23.0154C25.4736 22.8539 25.606 22.6604 25.6961 22.4464C25.7862 22.2325 25.8322 22.0025 25.8312 21.7704C25.8497 21.293 25.6777 20.8278 25.3532 20.4772C25.0287 20.1266 24.5782 19.9193 24.1008 19.9008C23.6234 19.8823 23.1582 20.0543 22.8076 20.3788C22.457 20.7033 22.2497 21.1538 22.2312 21.6312C22.2274 21.7893 22.1919 21.9451 22.1269 22.0893C22.0619 22.2335 21.9686 22.3631 21.8526 22.4706C21.7366 22.5782 21.6002 22.6613 21.4515 22.7152C21.3028 22.7691 21.1448 22.7926 20.9868 22.7844C20.6691 22.7719 20.3693 22.6338 20.1534 22.4005C19.9374 22.1672 19.8228 21.8577 19.8348 21.54C19.8689 20.7683 20.1151 20.021 20.5464 19.3802C20.9776 18.7394 21.5773 18.2299 22.2793 17.9078C22.9814 17.5857 23.7587 17.4635 24.5257 17.5545C25.2927 17.6455 26.0198 17.9463 26.627 18.4238C27.2341 18.9013 27.6979 19.5369 27.9672 20.2609C28.2365 20.9848 28.3009 21.769 28.1534 22.5272C28.0059 23.2854 27.6522 23.9883 27.1312 24.5585C26.6101 25.1287 25.9419 25.5442 25.2 25.7592Z" fill="white" />
    </svg>,
  ];
  const [cardData, setCardData] = useState([
    {
      icon: availableIcons[0],
      title: "Total FAQs",
      count: "--",
    },
    {
      icon: availableIcons[1],
      title: "General",
      count: "--",
    },
    {
      icon: availableIcons[2],
      title: "Updates",
      count: "--",
    },
    {
      icon: availableIcons[2],
      title: "News",
      count: "--",
    },
    {
      icon: availableIcons[3],
      title: "Total FAQs",
      count: "--",
    },
  ]);
  const pageSize = 10;

  const fetchData = async (data) => {
    try {
      const respones = await getFaqsApi(`?search=${data}`);
      if (respones?.status === 200) {
        setFaqsData(respones?.data);
        const dynamicCardData = Object.keys(respones?.data.extra_data).map((key) => ({
          icon: availableIcons[Math.floor(Math.random() * 4)],
          title: key === "all" ? "Total FAQs" : key,
          count: respones?.data.extra_data[key] || 0,
        }));
        setCardData(dynamicCardData);
      } else {
        let errors = "Opps! Something went wrong, please try again.";
        showAlert("Error", errors, "error");
      }
    } catch (error) {
      let errors =
        error?.response?.data?.detail ||
        "Opps! Something went wrong, please try again.";
      showAlert("Error", errors, "error");
    }
  };

  useEffect(() => {
    fetchData("");
  }, []);

  const openModal = (row) => {
    setIsOpen(true);
    setFaqsId(row?.id);
    setIsConfirmDelete(false);
  };

  const closeModal = () => {
    setIsOpen(false);
    setIsConfirmDelete(false);
  };
  useEffect(() => {
    if (isConfirmDelete === true) {
      const fetchData = async () => {
        try {
          const respones = await deleteFaqsApi(faqsId);
          if (respones?.status === 204) {
            try {
              const respones = await getFaqsApi();
              if (respones?.status === 200) {
                setFaqsData(respones?.data);
              } else {
                let errors = "Opps! Something went wrong, please try again.";
                showAlert("Error", errors, "error");
              }
            } catch (error) {
              let errors =
                error?.response?.data?.detail ||
                "Opps! Something went wrong, please try again.";
              showAlert("Error", errors, "error");
            }
            setIsOpen(false);
            showSuccessToast("Faq deleted successfully!");
          } else {
            let errors = "Opps! Something went wrong, please try again.";
            showAlert("Error", errors, "error");
          }
        } catch (error) {
          let errors =
            error?.response?.data?.detail ||
            "Opps! Something went wrong, please try again.";
          showAlert("Error", errors, "error");
        }
      };
      fetchData();
    }
  }, [isConfirmDelete]);
  const handleEdit = (rowData) => {
    navigate(`/faqs/edit-faqs`, { state: { rowData } });
  };

  const extraColumnRenderer = (row) => (
    <div className="flex space-x-2">
      <FiEdit
        size={23}
        onClick={() => handleEdit(row)}
        className="cursor-pointer text-primary"
      />
      <MdDelete
        size={25}
        onClick={() => openModal(row)}
        className="cursor-pointer text-red-600"
      />
    </div>
  );
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleSearch = (query) => {
    fetchData(query);
  };

  return (
    <div className="">
      <Toast />
      {/* Top Section Begin */}
      <div className="flex gap-3 items-center font-medium text-gray-500">
        <AiFillHome />
        <p>Home</p>
        <IoIosArrowForward />
        <p>FAQs</p>
      </div>
      {/* Top Section End */}
      {/* Add Faqs Begin */}
      <div className="flex justify-between pt-3">
        <div className="w-[30%]">
          <SearchBar placeholder="Search in FAQs..." onSearch={handleSearch} />
        </div>
        <div>
          <Link to="/faqs/add-faqs">
            <button
              type="button"
              className="text-white bg-primary hover:bg-primary-dark font-sm rounded-lg text-md w-full px-3 py-2.5 text-center flex items-center gap-1"
            >
              <IoMdAdd style={{ color: "white" }} size={23} />
              Add FAQs
            </button>
          </Link>
        </div>
      </div>
      {/* Add Faqs End */}
      {/* Card Section Begin */}
      <div className="py-3">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4">
          {cardData.map((card, index) => (
            <Card title={card.title} count={card.count} icon={card.icon} />
          ))}
        </div>
      </div>
      {/* Card Section End */}
      {/* Table Begin */}
      <div className="mt-2">
        <Table
          headers={headers}
          keys={keys}
          rows={faqsData?.results}
          extraColumn="Actions"
          extraColumnRenderer={extraColumnRenderer}
        />
      </div>
      {/* Table End */}
      {/* Pagination Begin */}
      <div className="xl:pl-5 pl-0">
        <Pagination
          currentPage={currentPage}
          totalPages={Math.ceil(faqsData?.count / pageSize)}
          pageSize={pageSize}
          totalEntries={faqsData?.count}
          onPageChange={handlePageChange}
          data={faqsData}
          setData={setFaqsData}
        />
      </div>
      {/* Pagination End */}
      <ConfirmModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Add FAQ Type Modal"
        onClose={closeModal}
        setIsConfirmDelete={setIsConfirmDelete}
      />
    </div>
  );
};

export default FAQs;
